import axiosInstance from '@/axiosInstance'
import { getApiUrl } from '@/helper'
import { URL } from '../../constatns'

export const loadData = async (payload) => {
  return axiosInstance.post(`${getApiUrl()}${URL}/by-date`, {
    data: payload
  })
}

export const getByDateAndUserId = async (payload, userId) => {
  return axiosInstance.post(`${getApiUrl()}${URL}/by-date-user/${userId}`, {
    data: payload
  })
}

export const loadDataByWorkingShift = async (workingShiftId) => {
  return axiosInstance.get(`${getApiUrl()}${URL}/working-shift/${workingShiftId}`)
}

export const getReturnedSales = async (userId, date) => {
  return axiosInstance.post(`${getApiUrl()}${URL}/returned/${userId}`, {
    data: date
  })
}

export const create = async (payload) => {
  return axiosInstance.post(`${getApiUrl()}${URL}`, {
    data: payload
  })
}

export const returnSale = async (id) => {
  return axiosInstance.get(`${getApiUrl()}${URL}/return/${id}`)
}

export const change = async (id, payload) => {
  return axiosInstance.post(`${getApiUrl()}${URL}/change/${id}`, {
    data: payload
  })
}

export const remove = async (id) => {
  return axiosInstance.delete(`${getApiUrl()}${URL}/${id}`)
}
